var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container"},[(_vm.loading)?_c('loader'):_c('workload-graph',{ref:"chart",staticStyle:{"height":"150px"},attrs:{"chart-data":_vm.workload,"legend":_vm.legend},on:{"click":_vm.route_to_record}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }